import { createSelector } from 'reselect';

const selectModule = state => state.carCreationWizard;

export default {
  getCurrentStepIdx: createSelector(selectModule, state => {
    return state.currentStepIdx;
  }),
  getTargetStepIdx: createSelector(selectModule, state => {
    return state.targetStepIdx;
  }),
  getSteps: createSelector(selectModule, state => {
    return state.steps;
  }),
  getAttrGroups: createSelector(selectModule, state => {
    return state.attrGroups;
  }),
  getFormErrors: createSelector(selectModule, state => {
    return state.formErrors;
  }),
};
